import * as Types from '../Types';
import * as MatchAPI from '../api/match';
export var RequestParam;
(function (RequestParam) {
    RequestParam["configurator"] = "configurator";
    RequestParam["affiliateId"] = "affiliateId";
    RequestParam["affiliateIdShort"] = "a";
    RequestParam["adServerClickPrefix"] = "adServerClickPrefix";
    RequestParam["updateApiInterval"] = "updateApiInterval";
    RequestParam["slide"] = "slide";
    RequestParam["language"] = "language";
    RequestParam["currency"] = "currency";
    RequestParam["oddsFormat"] = "oddsFormat";
    RequestParam["stake"] = "stake";
    RequestParam["sport"] = "sport";
    RequestParam["league"] = "league";
    RequestParam["region"] = "region";
    RequestParam["team"] = "team";
    RequestParam["teamFilter"] = "teamFilter";
    RequestParam["sortBy"] = "sortBy";
    RequestParam["beginBefore"] = "beginBefore";
    RequestParam["hideLiveScores"] = "hideLiveScores";
    RequestParam["matchCount"] = "matchCount";
    RequestParam["template"] = "template";
    RequestParam["size"] = "size";
    RequestParam["autoFill"] = "autoFill";
    RequestParam["mocks"] = "mocks";
    RequestParam["overview"] = "overview";
    RequestParam["market"] = "market";
    RequestParam["contestId"] = "contestId";
    RequestParam["outrightOutcome"] = "outrightOutcome";
    RequestParam["country"] = "country";
    RequestParam["theme"] = "theme";
    RequestParam["retargeting"] = "retargeting";
    RequestParam["urlContextSensitive"] = "urlContextSensitive";
    RequestParam["urlContextSensitiveUrl"] = "urlContextSensitiveUrl";
    RequestParam["campaignCount"] = "campaignCount";
    RequestParam["debug"] = "debug";
    RequestParam["passThrough"] = "passThrough";
    RequestParam["customerId"] = "customerId";
    RequestParam["customerBetslipSelection"] = "customerBetslipSelection";
})(RequestParam || (RequestParam = {}));
export const CustomParameterPrefix = 'custom_';
let urlSearchParams;
let requestParams;
export function init(url, config, options) {
    var _a, _b, _c;
    const urlObject = new URL(url);
    const [adServerClickPrefix, rest] = getAdServerClickPrefix(urlObject.search);
    urlObject.search = rest;
    urlSearchParams = urlObject.searchParams;
    const sizeParam = urlSearchParams.get(RequestParam.size);
    const template = validateTemplate(urlSearchParams.get(RequestParam.template), sizeParam, config.supportedTemplates, config.defaults.template);
    const size = validateSize(urlSearchParams.get(RequestParam.size), urlSearchParams.get(RequestParam.template), template ? config.getSupportedSizesByTemplate(template) : []);
    const language = getLanguage(config.supportedLanguages, config.defaults.language);
    const defaultSlides = config.getDefaultSlides(language);
    const passThroughParameters = getCleanPassThroughParameters(urlSearchParams);
    const affiliateId = ((_a = passThroughParameters.get(RequestParam.affiliateId)) !== null && _a !== void 0 ? _a : passThroughParameters.get(RequestParam.affiliateIdShort)) ||
        undefined;
    passThroughParameters.delete(RequestParam.affiliateId);
    passThroughParameters.delete(RequestParam.affiliateIdShort);
    const configurator = urlSearchParams.get(RequestParam.configurator) === 'true';
    requestParams = {
        [RequestParam.configurator]: configurator,
        [RequestParam.passThrough]: passThroughParameters,
        [RequestParam.slide]: validateSlides(urlSearchParams.getAll(RequestParam.slide), Number(urlSearchParams.get(RequestParam.campaignCount) || config.defaults.campaignCount), Number(urlSearchParams.get(RequestParam.matchCount) || config.defaults.matchCount), config.supportedSlideTypes, config.fallbackCreativeId, defaultSlides),
        [RequestParam.language]: language,
        [RequestParam.currency]: validateParamWithDefault(urlSearchParams.get(RequestParam.currency), config.supportedCurrencies, config.defaults.currency),
        [RequestParam.oddsFormat]: validateParamWithDefault(urlSearchParams.get(RequestParam.oddsFormat), config.supportedOddsFormats, config.defaults.oddsFormat),
        [RequestParam.stake]: getStake(urlSearchParams.get(RequestParam.stake), config.defaults.stake),
        [RequestParam.updateApiInterval]: urlSearchParams.get(RequestParam.updateApiInterval) || String(config.defaults.updateInterval),
        [RequestParam.adServerClickPrefix]: adServerClickPrefix,
        [RequestParam.matchCount]: urlSearchParams.get(RequestParam.matchCount) || String(config.defaults.matchCount),
        [RequestParam.affiliateId]: affiliateId,
        [RequestParam.campaignCount]: urlSearchParams.get(RequestParam.campaignCount) || String(config.defaults.campaignCount),
        [RequestParam.sport]: validateParam(urlSearchParams.get(RequestParam.sport), config.supportedSports || Object.keys(MatchAPI.Sport)),
        [RequestParam.region]: urlSearchParams.get(RequestParam.region) || undefined,
        [RequestParam.league]: urlSearchParams.get(RequestParam.league) || undefined,
        [RequestParam.team]: urlSearchParams.get(RequestParam.team) || undefined,
        [RequestParam.teamFilter]: urlSearchParams.get(RequestParam.teamFilter) || undefined,
        [RequestParam.template]: template,
        [RequestParam.theme]: validateParamWithDefault(urlSearchParams.get(RequestParam.theme), config.supportedThemes, config.defaults.theme),
        [RequestParam.size]: size,
        [RequestParam.sortBy]: validateParamWithDefault(urlSearchParams.get(RequestParam.sortBy), Object.keys(MatchAPI.SortBy), config.defaults.sortBy),
        [RequestParam.beginBefore]: urlSearchParams.get(RequestParam.beginBefore) || undefined,
        [RequestParam.hideLiveScores]: getHideLiveScores(urlSearchParams),
        [RequestParam.autoFill]: urlSearchParams.get(RequestParam.autoFill) || undefined,
        [RequestParam.market]: validateParam(urlSearchParams.get(RequestParam.market), template ? config.getSupportedBettingTypesByTemplate(template) : []),
        [RequestParam.mocks]: urlSearchParams.get(RequestParam.mocks) || undefined,
        [RequestParam.overview]: urlSearchParams.get(RequestParam.overview) || undefined,
        [RequestParam.contestId]: urlSearchParams.get(RequestParam.contestId) || undefined,
        [RequestParam.outrightOutcome]: urlSearchParams.get(RequestParam.outrightOutcome) || undefined,
        [RequestParam.country]: validateParam(urlSearchParams.get(RequestParam.country), config.supportedCountries),
        [RequestParam.retargeting]: urlSearchParams.get(RequestParam.retargeting) || undefined,
        [RequestParam.urlContextSensitive]: urlSearchParams.get(RequestParam.urlContextSensitive) || undefined,
        [RequestParam.urlContextSensitiveUrl]: urlSearchParams.get(RequestParam.urlContextSensitiveUrl) || undefined,
        [RequestParam.debug]: urlSearchParams.get(RequestParam.debug) || undefined,
        [RequestParam.customerId]: configurator || !options.personalized ? undefined : (_b = config.getCustomerId) === null || _b === void 0 ? void 0 : _b.call(config),
        [RequestParam.customerBetslipSelection]: configurator || !options.personalized ? undefined : (_c = config.getCustomerBetslipSelection) === null || _c === void 0 ? void 0 : _c.call(config)
    };
    return requestParams;
}
export function getRequestParams() {
    return requestParams;
}
export function getHideLiveScores(urlSearchParams) {
    if (urlSearchParams.get(RequestParam.beginBefore))
        return 'true';
    return urlSearchParams.get(RequestParam.hideLiveScores) || undefined;
}
export function getCleanPassThroughParameters(urlSearchParams) {
    const passThroughParameters = new URLSearchParams();
    urlSearchParams.forEach((value, key) => {
        if (isPassThroughParameter(key))
            passThroughParameters.append(key.replace(CustomParameterPrefix, ''), value);
    });
    return passThroughParameters;
}
export function isPassThroughParameter(key) {
    return key.startsWith(CustomParameterPrefix);
}
export function toPassThroughParameter(key) {
    return `${CustomParameterPrefix}${key}`;
}
export function fromPassThroughParameter(key) {
    return key.substring(CustomParameterPrefix.length);
}
export function getPassThroughParameter(requestParams, key) {
    return new URLSearchParams(requestParams.passThrough).get(key) || undefined;
}
export function isEqualSlideDescription(a, b) {
    if (a.type !== b.type)
        return false;
    if (a.type === Types.SlideType.Creative && b.type === Types.SlideType.Creative)
        return a.id === b.id;
    return true;
}
export function validateSlides(slideDescriptions, campaignCount, matchCount, supportedSlideTypes, fallbackCreativeId, defaultSlides) {
    let result = [];
    const validatedSlideDescriptions = slideDescriptions
        .map(decodeSlideDescription)
        .filter((slide) => slide !== null && supportedSlideTypes.includes(slide.type));
    if (validatedSlideDescriptions.length > 0) {
        result = validatedSlideDescriptions;
    }
    else {
        let campaignsOrCreatives = [];
        if (campaignCount) {
            if (supportedSlideTypes.includes(Types.SlideType.Campaign)) {
                campaignsOrCreatives = Array(Number(campaignCount)).fill({ type: Types.SlideType.Campaign });
            }
            else if (supportedSlideTypes.includes(Types.SlideType.Creative)) {
                if (fallbackCreativeId) {
                    campaignsOrCreatives = [{ type: Types.SlideType.Creative, id: fallbackCreativeId }];
                }
            }
        }
        const matches = Array(Number(matchCount)).fill({ type: Types.SlideType.Match });
        result = campaignsOrCreatives.concat(matches);
    }
    result = [
        ...defaultSlides.before.filter(slide => !result.find(sd => isEqualSlideDescription(sd, slide))),
        ...result,
        ...defaultSlides.after.filter(slide => !result.find(sd => isEqualSlideDescription(sd, slide)))
    ];
    return result;
}
export function encodeSlideDescription(slideDescription) {
    const encodedSlideDescription = [];
    encodedSlideDescription.push(slideDescription.type.toLowerCase());
    switch (slideDescription.type) {
        case Types.SlideType.Creative:
            if (slideDescription.id) {
                encodedSlideDescription.push(slideDescription.id);
            }
            break;
        default:
            break;
    }
    return encodedSlideDescription.join('_');
}
export function decodeSlideDescription(slideDescription) {
    const [type, ...rest] = slideDescription.split('_');
    const id = rest.join('_');
    switch (type.toLowerCase()) {
        case Types.SlideType.Match.toLowerCase():
            return { type: Types.SlideType.Match };
        case Types.SlideType.Creative.toLowerCase():
            if (!id)
                return null;
            return { type: Types.SlideType.Creative, id };
        case Types.SlideType.Campaign.toLowerCase():
            return { type: Types.SlideType.Campaign };
        default:
            return null;
    }
}
export function validateTemplate(template, size, supportedTemplates, defaultTemplate) {
    if (template) {
        const parsedTemplate = getTemplateAndSize(template);
        if (parsedTemplate) {
            const [template] = parsedTemplate;
            return validateParam(template, supportedTemplates) || null;
        }
        return validateParam(template, supportedTemplates) || null;
    }
    if (size) {
        return defaultTemplate;
    }
    return undefined;
}
export function validateSize(size, template, supportedSizes) {
    if (template) {
        // Support for legacy template with size
        const parsedTemplate = getTemplateAndSize(template);
        if (parsedTemplate) {
            const [, size] = parsedTemplate;
            return validateParam(size, supportedSizes) || null;
        }
    }
    if (!size)
        return undefined;
    if (size === 'auto') {
        return getAutoSize(window.innerWidth, window.innerHeight, supportedSizes);
    }
    else {
        return validateParam(size, supportedSizes) || null;
    }
}
export function getStake(maybeStake, defaultStake) {
    if (maybeStake) {
        let stake = Number(maybeStake);
        if (!isNaN(stake))
            return stake;
    }
    return defaultStake;
}
export function getAdServerClickPrefix(searchQuery) {
    let [rest, adServerClickPrefix] = searchQuery.split(`${RequestParam.adServerClickPrefix}=`);
    if (adServerClickPrefix) {
        try {
            adServerClickPrefix = decodeURIComponent(adServerClickPrefix);
        }
        catch (e) {
            console.error(e);
        }
    }
    return [adServerClickPrefix || '', rest];
}
export function validateParamWithDefault(value, supportedValues, defaultValue) {
    const validValue = validateParam(value, supportedValues);
    if (validValue) {
        return validValue;
    }
    else {
        return defaultValue;
    }
}
export function validateParam(value, supportedValues) {
    if (supportedValues.includes(value)) {
        return value;
    }
    return undefined;
}
export function validateParams(values, supportedValues, defaultValues) {
    if (!values || values.length === 0)
        return defaultValues;
    return values.map(value => validateParam(value, supportedValues)).filter(Boolean);
}
export function getLanguage(supportedLanguages, defaultLanguage) {
    const languageFromUrl = new URLSearchParams(window.location.search).get(RequestParam.language);
    if (languageFromUrl && supportedLanguages.indexOf(languageFromUrl) !== -1)
        return languageFromUrl;
    if (window.navigator.language) {
        const languageWithLocaleFromNavigator = window.navigator.language.substring(0, 4);
        if (supportedLanguages.indexOf(languageWithLocaleFromNavigator) !== -1) {
            return languageWithLocaleFromNavigator;
        }
        const languageFromNavigator = window.navigator.language.substring(0, 2);
        if (supportedLanguages.indexOf(languageFromNavigator) !== -1) {
            return languageFromNavigator;
        }
    }
    return defaultLanguage;
}
export function getTemplateAndSize(templateName) {
    const match = templateName.match(/^([a-z]+)(\d+x\d+)$/i);
    if (match) {
        return [match[1], match[2]];
    }
    return null;
}
export function getLocaleForLanguage(language) {
    switch (language) {
        case Types.Language.en:
            return 'en-US';
        default:
            return language;
    }
}
export function getAutoSize(width, height, supportedSizes) {
    console.group('Determining the best fitting size');
    const optimalSize = supportedSizes
        // .filter((key) => {
        //     switch (key) {
        //         case Size['1920x1080']:
        //             return false;
        //         default:
        //             return true;
        //     }
        // })
        .map(key => {
        const [bannerWidth, bannerHeight] = key.split('x').map(v => Number(v));
        return {
            key,
            aspectRatioDiff: Math.abs(bannerWidth / bannerHeight - width / height),
            boundaryDiff: Math.abs(bannerWidth - width) + Math.abs(bannerHeight - height)
        };
    })
        .reduce((previous, sizeObject) => {
        if (!previous)
            return sizeObject;
        if (sizeObject.aspectRatioDiff < previous.aspectRatioDiff) {
            return sizeObject;
        }
        if (sizeObject.aspectRatioDiff === previous.aspectRatioDiff &&
            sizeObject.boundaryDiff < previous.boundaryDiff) {
            return sizeObject;
        }
        return previous;
    }, undefined).key;
    console.log(`Optimal size for ${width}x${height} is ${optimalSize}`);
    console.groupEnd();
    return optimalSize;
}
export function getContextSensitiveURL(requestParams) {
    var _a;
    const urlContextSensitivityActivated = requestParams.urlContextSensitive === 'true';
    if (!urlContextSensitivityActivated) {
        return undefined;
    }
    else {
        try {
            return requestParams.urlContextSensitiveUrl || ((_a = window.top) === null || _a === void 0 ? void 0 : _a.location.href);
        }
        catch (e) {
            console.warn(e);
            return undefined;
        }
    }
}
//# sourceMappingURL=RequestParams.js.map